import React, { Component } from 'react';
import SidebarMenuRouters from '../../routers/routers.js';
import Header from '../../containers/header.js';
import { COLORS } from '../../utils/constants';
import SimpleMonthPicker from '../../components/ui-components/SimpleMonthPicker';
import CorrectiveActions from '../../components/tables/correctiveActions';
import AuditCompliance from '../../charts/auditCompliance';
import SatisfactionIndex from '../../components/satisfactionIndex/satisfactionIndex';
import MonthlyClaims from '../../components/monthlyClaims';
import * as Parse from "../../utils/parsers";
import * as Format from "../../utils/formatters";
export const BoxSingle = (props) => {

  return (
    <div className="iconbox-single" style={{height: '80%', minWidth: '50%', marginBottom: '0', marginRight: '0' +
        ''}}>
      <div className="box-title">
        <div>
          <h5 style={{color: COLORS.SUMMARY_GREEN}}>{props.title}</h5>
          <p style={{color: COLORS.SUMMARY_GRAY}}>{props.subtitle}</p>
        </div>
      </div>
      <div className="chart">
        {props.children}
      </div>
    </div>
  )
};

class Quality extends Component {
  constructor (props) {
    super(props);
    let userData = JSON.parse(localStorage.getItem('userData'));
    let date = new Date();
    let today = Parse.toCustomDateLastDay(date);
    let dateModal = Format.formatStringMonth(Parse.toGetMonth(today))+' '+Parse.toGetYear(today);
    this.state = {userData: userData, date: today, data: null, dateModal: dateModal, dateModalNumber: date.getMonth()+1 };
  }

  callback = (dataFromChild) => {
    let date = Parse.toCustomDateLastDay(dataFromChild);
    let dateModal = Format.formatStringMonth(Parse.toGetMonth(date))+' '+Parse.toGetYear(date);
    this.setState({date: date, dateModal: dateModal, dateModalNumber:dataFromChild.getMonth()+1, key: Math.floor(Math.random() * 11)});
  };

  render () {

    const authorization= (this.state.userData.name === 'Gerente de calidad');

    return (
      <div>
        <SidebarMenuRouters profile="/direction-home/" place={''}/>
        <Header userName={this.state.userData.name} title={'Calidad'}/>
        <div className={'row'}>
          <div className={'col-lg-9 col-md-8 col-sm-7 col-5 header-quality'}>
            <p>Indicadores de calidad</p>
          </div>
          <div className={'col-lg-3 col-md-4 col-sm-5 col-7'}>
            <BoxSingle
              title={<SimpleMonthPicker callbackFromParent={this.callback}/>}
              subtitle="Periodo"
            >
            </BoxSingle>
          </div>
        </div>
        <div className={'row pr-0 pl-0'}>
          <div className={'col-12 pr-0 pl-0'}>
            <CorrectiveActions key={this.state.key} date={this.state.date} authorization={authorization} dateModal={this.state.dateModal}/>
          </div>
        </div>
        <div className={'row mt-3 pr-0 pl-0'}>
          <div className={'col-12 pr-0 pl-0'}>
            <AuditCompliance key={this.state.key} date={this.state.date} authorization={authorization} dateModal={this.state.dateModal}/>
          </div>
        </div>
        <div className={'row pr-0 pl-0'}>
          <div className={'col-12 pr-0 pl-0'}>
            <SatisfactionIndex key={this.state.key} date={this.state.date} authorization={authorization} dateModal={this.state.dateModal}  dateModalNumber={this.state.dateModalNumber}/>
          </div>
        </div>
        <div className={'row pr-0 pl-0'}>
          <div className={'col-12 pr-0 pl-0'}>
            <MonthlyClaims key={this.state.key} date={this.state.date} authorization={authorization} dateModal={this.state.dateModal}/>
          </div>
        </div>
      </div>
    )
  }
}

export default Quality



// WEBPACK FOOTER //
// ./src/scene/quality/quality.js